import Link from 'next/link';

const Footer = () => (
    <footer className="bg-white text-gray-900 p-4 mt-auto border-t border-gray-200">
        <div className="container mx-auto text-center space-x-4">
            <Link legacyBehavior href="/agb">
                <a className="hover:text-gray-600">AGB</a>
            </Link>
            <Link legacyBehavior href="/datenschutz">
                <a className="hover:text-gray-600">Datenschutz</a>
            </Link>
            <Link legacyBehavior href="/impressum">
                <a className="hover:text-gray-600">Impressum</a>
            </Link>
        </div>
    </footer>
);

export default Footer;
